import { GoogleIcon, InstagramIcon, TikTokIcon } from '../Icons';
import { MetricIcon, PricePointMetricIcon } from '../HealthStats';
import ClusterIcon from '../ClusterIcon';
import OverviewCardWrapper from './OverviewCardWrapper';
import { TableRowBody } from '../DataVis/DataTable/styledComponents';
import { getClusterScore } from './ClusterStat';
import { getScoreColor } from 'utils/helpers';
import styled from 'styled-components';
import { tooltips } from '@/copy';

export const Title = styled.span`
    font-weight: ${({ theme }) => theme.fontBold};
    line-height: ${({ theme }) => theme.space9}px;
    margin-bottom: ${({ theme }) => theme.space_1}px;
    text-transform: capitalize;
    padding: 0px ${({ theme }) => theme.space_8}px;
`;

export const TimeseriesWrapper = styled.span`
    margin-top: auto;
    margin-bottom: ${({ theme }) => theme.space_8}px;
    height: 56px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding: 0px ${({ theme }) => theme.space_8}px;
`;

export const TimeseriesInnerWrapper = styled.span`
    width: 100%;
    height: 100%;
`;

export const CardStats = styled.span`
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    border-top: solid 1px ${({ theme }) => theme.gray_5};
    padding: ${({ theme }) => `${theme.space_6}px ${theme.space_8}px`};
    background-color: ${({ theme }) => theme.gray_6};
`;

const CardStatWrapper = styled.span`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    flex-basis: 20%;
    gap: 0.35rem;
`;

export const CardStatIcon = styled.span`
    font-size: ${({ theme }) => theme.space_9}px;
    line-height: ${({ theme }) => theme.space_10}px;
    color: ${({ score, metricLabel }) =>
        getScoreColor(score, false, metricLabel)};

    ${OverviewCardWrapper}:not(:hover):not(:focus-visible) & {
        color: ${({ theme }) => theme.gray_600};
    }
    ${TableRowBody}:not(:hover):not(:focus-visible) & {
        color: ${({ theme }) => theme.gray_600};
    }
`;

const ClusterIconWrapper = styled.span`
    display: inline-flex;
    ${OverviewCardWrapper}:not(:hover):not(:focus-visible) & {
        filter: grayscale(1) opacity(0.5);
    }
    ${TableRowBody}:not(:hover):not(:focus-visible) & {
        filter: grayscale(1) opacity(0.5);
    }
`;

const CardStatMetric = styled.span`
    font-size: ${({ theme }) => theme.fontSize_sm};
    font-weight: ${({ theme }) => theme.fontBold};
    text-transform: uppercase;
    color: ${({ score, metricLabel }) =>
        getScoreColor(score, true, metricLabel)};
    ${OverviewCardWrapper}:not(:hover):not(:focus-visible) & {
        color: ${({ theme }) => theme.gray_1};
    }
    ${TableRowBody}:not(:hover):not(:focus-visible) & {
        color: ${({ theme }) => theme.gray_1};
    }
`;

function CardStatIconInner({ score, metricLabel }) {
    if (metricLabel === 'price point' && score > 0) {
        return (
            <PricePointMetricIcon score={score} style={{ fontSize: '.9em' }} />
        );
    }

    if (metricLabel === 'popularity share' && score >= 8) {
        return (
            <GoogleIcon
                css={`
                    font-size: 0.8em;
                `}
            />
        );
    }

    if (metricLabel === 'popularity share' && score >= 7) {
        return (
            <TikTokIcon
                css={`
                    font-size: 0.8em;
                `}
            />
        );
    }

    if (metricLabel === 'popularity share' && score >= 6) {
        return (
            <InstagramIcon
                css={`
                    font-size: 0.8em;
                `}
            />
        );
    }

    return (
        <MetricIcon
            metricLabel={metricLabel}
            css={`
                font-size: 0.8em;
            `}
        />
    );
}

export function CardStat({ score, scoreLabel, metricLabel, metric }) {
    return (
        <CardStatWrapper>
            <CardStatIcon
                score={score}
                metricLabel={metricLabel}
                title={`${metricLabel}: ${scoreLabel}`}
            >
                <CardStatIconInner score={score} metricLabel={metricLabel} />
            </CardStatIcon>
            <CardStatMetric score={score} metricLabel={metricLabel}>
                {metricLabel === 'price point' ? (
                    <span css="text-transform: capitalize;">
                        {scoreLabel === tooltips.healthStatsMissingScoreLabel
                            ? '-'
                            : scoreLabel}
                    </span>
                ) : (
                    metric
                )}
            </CardStatMetric>
        </CardStatWrapper>
    );
}
